import { ActivityLogDetailValue, FullObject } from '@/api';
import {
  formatEditorString,
  getConditionTemplateName,
  isNotEmpty,
  parseOrganTitle,
} from '@/shared/util';

import { ACTIVITY_LOG_DEFAULT_VALUES } from './activity-log.constant';

export const generateTitle = (
  title: string,
  fullObject: FullObject | null = {},
  isConditionTemplateDisplayNameEnabled: boolean,
) => {
  const { reportFindings = [], template } = fullObject || {};

  let result = '';

  if (isNotEmpty(reportFindings)) {
    const template = reportFindings[0]?.template;

    result = `${parseOrganTitle(template?.organ || '')} > ${getConditionTemplateName({ condition: template?.condition ?? '', displayName: template?.displayName ?? undefined }, isConditionTemplateDisplayNameEnabled)} > ${template?.uuid} > `;
  } else if (isNotEmpty(template)) {
    result = `${parseOrganTitle(template.organ || '')} > ${getConditionTemplateName(template, isConditionTemplateDisplayNameEnabled)} > ${template.uuid} > `;
  }

  result += `${title}`;

  return result;
};

export const formatValue = (data: ActivityLogDetailValue) => {
  if (ACTIVITY_LOG_DEFAULT_VALUES[data as keyof typeof ACTIVITY_LOG_DEFAULT_VALUES]) {
    return ACTIVITY_LOG_DEFAULT_VALUES[data as keyof typeof ACTIVITY_LOG_DEFAULT_VALUES];
  }

  if (data === null) {
    return 'Created with empty values';
  }

  if (Array.isArray(data)) {
    return isNotEmpty(data) ? data.join(', ') : 'Created with empty values';
  }

  return formatEditorString(String(data));
};

export const shouldRenderArrow = (
  currentValue: ActivityLogDetailValue,
  previousValue: ActivityLogDetailValue,
): boolean => {
  const isValidValue = (value: ActivityLogDetailValue) =>
    value !== null && value !== undefined && (typeof value === 'string' ? isNotEmpty(value) : true);

  return isValidValue(currentValue) && isValidValue(previousValue);
};
